// extracted by mini-css-extract-plugin
module.exports = {"youTubeEmbed":"YouTubeEmbed_youTubeEmbed__Wa-s_"};